export default "__VITE_ASSET__CEPeHSQt__"